import React from 'react';
import Modal from 'react-bootstrap/Modal';
import CloseIcon from 'resources/X_close_icon.png';
import WStoreIcon from 'resources/FeatureIcons/Button-WStore.svg';
import './WStoreConfirmationNew.css';

const PurchaseTradeConfirmationBody = props => (
  <div className="confirmation-body">
    <img src={WStoreIcon} alt="WStore Icon" className="wstore-icon" />
    <div className="current-location">{props.preferredLocation}</div>
    <div className="title">{props.purchaseResponseMsg}</div>
    <div className="confirmation-message">{props.purchaseEmailMsg}</div>
    <button
      type="button"
      className="close-wstore-confirmation-button "
      onClick={props.onClose}
    >
      Close
    </button>
  </div>
);

function WStoreConfirmationNew(props) {
  return (
    <Modal
      className="wstore-confirmation-modal-new"
      show={true}
      onHide={props.onClose}
    >
      <Modal.Body>
        <button
          className="exit-modal-button"
          type="button"
          onClick={props.onClose}
        >
          <img src={CloseIcon} alt="Close purchase modal" />
        </button>
        <PurchaseTradeConfirmationBody {...props} />
      </Modal.Body>
    </Modal>
  );
}

export default WStoreConfirmationNew;
